import React from "react";
import {
  Box,
  IconButton,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import { useGetUserTransactionsQuery } from "../../services/user";
import { useParams } from "react-router-dom";

interface TransactionHistoryProps {
  hideUserColumn?: boolean;
}

const TransactionHistory: React.FC<TransactionHistoryProps> = ({ hideUserColumn }) => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { data: userTransactions } = useGetUserTransactionsQuery(id ? { id } : ({ id: '' } as any), { skip: !id });


  return (
    <TableContainer className="table_container">
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Receipt ID</TableCell>
            <TableCell>Transaction Date</TableCell>
            {!hideUserColumn && <TableCell>User</TableCell>}
            <TableCell>Source</TableCell>
            <TableCell>Type</TableCell>
            <TableCell>Points</TableCell>
            <TableCell>Transaction Status</TableCell>
            <TableCell>Actions</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {(userTransactions?.data?.list || []).length === 0 ? (
            <TableRow>
              <TableCell colSpan={8} align="center">No data found</TableCell>
            </TableRow>
          ) : (
            (userTransactions?.data?.list || []).map((tx: any) => {
              const value = tx?.entryType === 'Expire' ? (tx?.expiredPoints || 0) : (tx?.points || 0);
              const isPositive = tx?.entryType === 'Collected';
              const signed = isPositive ? value : -value;
              const user = tx?.userDetails || {};
              return (
                <TableRow key={tx?._id}>
                  <TableCell>{tx?.receiptNo || '-'}</TableCell>

                  <TableCell>{tx?.createdAt ? new Date(tx.createdAt).toLocaleString() : '-'}</TableCell>
                  {!hideUserColumn && (
                    <TableCell>
                      <Box component="a" onClick={(e) => {
                        e.preventDefault();
                        navigate("/manage-users/detail", { state: { id: tx?.userId } });
                      }}
                        className="user_block click_action">
                        <p>
                          <b>{user?.fullName || '-'}</b>
                          <span>{`${user?.dialCode || ''} ${user?.phoneNo || ''}`.trim()}</span>
                          <span>{user?.email || ''}</span>
                        </p>
                      </Box>
                    </TableCell>
                  )}
                  <TableCell>{tx?.location || '-'}</TableCell>

                  <TableCell>{tx?.entryType || '-'}</TableCell>
                  <TableCell>
                    <p className={`status_btn ${signed > 0 ? 'c_success' : 'c_danger'}`}>
                      {`${signed > 0 ? '+' : ''}${signed} pts`}
                    </p>
                  </TableCell>

                  <TableCell>
                    <p className={`status_btn dark c_warning`}>
                      -
                    </p>
                  </TableCell>
                  <TableCell>
                    <div className="table_actions v2">
                      <Box>
                        <IconButton
                          onClick={() => navigate("/manage-transactions/view", { state: { id: tx?._id } })}>
                          <img src="/static/images/eye_icon.svg" alt="View" />
                        </IconButton>
                      </Box>
                    </div>
                  </TableCell>
                </TableRow>
              );
            })
          )}
        </TableBody>
      </Table>
    </TableContainer>
  );
};

export default TransactionHistory;
